<template>
  <span class="tip" v-if="title">
    <i
      class="fal fa-exclamation-circle"
      :title="title"
      v-b-popover.hover.top="description"
    ></i>
  </span>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Tip",
  props: {
    field: String,
    formName: String,
  },
  data() {
    return {
      title: "",
      description: "",
    };
  },
  mounted() {
    let tip = this.tip({ field: this.field, formName: this.formName });
    if (tip) {
      this.title = tip.title;
      this.description = tip.description;
    }
  },
  computed: {
    ...mapGetters("generic", ["tip"]),
  },
};
</script>

<style scoped>
.tip {
  cursor: pointer;
}
</style>
